import { LinkStyles, SVG } from "@at/design-system-elements";
import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils/lib/responsive-utils/match-media.util";
import styled, { css } from "styled-components";

import { isUserInRedButtonTest } from "../../../utils/ab-test/ab-test.util";
import { ResetButtonStyles } from "../../../utils/styles/buttons.styles";
import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";
import { MobilePadding } from "../advert-overview.styles";

export const ChargingText = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
`;
export const ModalBodyStyled = styled.div`
  h2 {
    margin-bottom: 16px;
  }

  p {
    margin: 16px 0;
  }
`;

export const ChargingTextInfo = styled.span`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 14px;
  align-items: center;
  margin-bottom: "20px";
  svg.how-long-to-charge {
    margin: 1px 0;
    ${PrintStyleSheet}
  }
`;

export const Container = styled.section`
  border-bottom: none;
  margin-top: 12px;
  padding-left: 16px;
  margin-right: 16px;
  @media (min-width: 768px) {
    border-bottom: none;
    margin-top: 24px;
    padding: 0 0 8px;
    margin-right: 0;
  }
  @media print {
    page-break-before: always;
  }
`;
export const TypeOfCharging = styled.div`
  margin: ${({ theme }) =>
    `${ThemeSelectors.getGroupFourSpacing(
      theme,
    )} 0 ${ThemeSelectors.getGroupOneSpacing(theme)}`};
  justify-content: space-between;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};

  @media (min-width: 375px) {
    flex-direction: row;
  }

  @media (min-width: 560px) {
    flex-direction: column;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }

  [data-full-width="false"] & {
    @media (min-width: 1000px) {
      flex-direction: column;
    }

    @media (min-width: 1225px) {
      flex-direction: row;
    }
  }
`;

export const InfoButtonStyled = styled(ResetButtonStyles)`
  ${({ theme }) => LinkStyles(theme)};
  border: none;
  font-size: inherit;
  padding-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  ${PrintStyleSheet}

  &.new-overview {
    padding-left: 4px;
    margin: 0;
  }

  &.is-inline-paragraph {
    display: inline-block;
    vertical-align: sub;
    position: relative;
  }

  svg,
  path {
    display: flex;
    align-items: center;
    line-height: 1;
    margin: 3px 0;
    justify-content: center;
    fill: currentColor;
    position: relative;
  }
`;

export const ChargingElement = styled.div`
  ${({ theme }) => {
    const gridUnit = ThemeSelectors.getGridUnit(theme);

    return css`
      background: ${({ theme }) =>
        isUserInRedButtonTest
          ? ThemeSelectors.getLightGrey(theme)
          : ThemeSelectors.getColorDecorBgSurfaceSoft(theme)};
      border-radius: 4px;
      padding: calc(${gridUnit} * 2) calc(${gridUnit} * 2)
        calc(${gridUnit} * 1.5);
      width: 100%;

      @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
        border-bottom: none;
      }
      @media print {
        border: 1px solid ${({ theme }) => ThemeSelectors.getGrey(theme)};
      }
    `;
  }}
  display: flex;
  flex-direction: column;
`;
export const ChargingCalculator = styled.div`
  ${({ theme }) => {
    const gridUnit = ThemeSelectors.getGridUnit(theme);

    return css`
      padding: 24px;
      background: ${({ theme }) =>
        isUserInRedButtonTest
          ? ThemeSelectors.getLightGrey(theme)
          : ThemeSelectors.getColorDecorBgSurfaceSoft(theme)};
      margin-top: 16px;

      h3 {
        margin-bottom: 16px;
      }

      & .atds-field {
        margin: calc(${gridUnit} * 2) 0;
      }

      @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
        border-bottom: none;

        .contact-card {
          padding: 0;
          margin: ${gridUnit} 0 0;
        }
      }
    `;
  }}
`;
export const EstimateBacking = styled.div`
  ${({ theme }) => {
    const gridUnit = ThemeSelectors.getGridUnit(theme);

    return css`
      background: ${({ theme }) =>
        isUserInRedButtonTest
          ? ThemeSelectors.getLightGrey(theme)
          : ThemeSelectors.getColorDecorBgSurfaceSoft(theme)};
      padding: 24px;
      padding-top: 0;

      @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
        border-bottom: none;

        .contact-card {
          padding: 0;
          margin: ${gridUnit} 0 0;
        }
      }

      p:first-of-type {
        margin-top: 0;
      }

      p:last-of-type {
        margin-bottom: 0;
      }
    `;
  }}
`;
export const ElectricIcon = styled(SVG)`
  margin-right: 6px;
  width: 24px;
  height: 24px;
`;

export const InputIconLabelWrapper = styled.div`
  ${({ theme }) => {
    const color = ThemeSelectors.getLegacyBlue(theme);
    return css`
      display: flex;
      align-items: center;
      margin: 16px 0 12px;

      .electric-label {
        margin-top: 4px;
        color: ${color};
      }
    `;
  }}
`;

export const ChargingSubHeader = styled.span`
  ${({ theme }) => {
    const colourBlue = ThemeSelectors.getLegacyBlue(theme);
    return css`
      display: flex;
      margin: 0;
      color: ${colourBlue};
      @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
        margin: 0;
      }
    `;
  }}
`;
export const ElectricWrapperStyled = styled.div`
  margin-bottom: 24px;
  @media (min-width: 560px) {
    width: 48%;
  }

  @media (min-width: 768px) {
    width: 100%;
    margin: 0;
  }

  @media print {
    a {
      ${PrintStyleSheet}
    }
  }

  @media (min-width: 1000px) {
    width: 100%;
  }
`;
export const ChargingTabsDetails = styled.div`
  margin: 0 0 16px 0;
  width: 100%;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  display: flex;
  flex-direction: column;

  @media (min-width: 560px) {
    justify-content: space-between;
    flex-direction: row;
  }

  [data-full-width="false"] & {
    @media (min-width: 768px) {
      flex-direction: column;
    }

    @media (min-width: 1000px) {
      gap: 3em;
      flex-direction: row;
    }
  }
`;
export const VehicleInformation = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => ThemeSelectors.getLegacyGrey(theme)};
  padding-top: 12px;
  padding-bottom: 12px;
  ${MobilePadding}
  ${PrintStyleSheet}
`;
export const BulletsList = styled.ul`
  list-style: none;
  margin-bottom: calc(${({ theme }) => ThemeSelectors.getGridUnit(theme)} * 2);
  padding-left: 24px;
`;

export const BulletsItem = styled.li`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  list-style: disc;
  padding-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;
